import React from "react";
import { useTheme, lighten } from "@mui/material/styles";
import { darken, Grid, Typography } from "@mui/material";

const MyTeamPayrollOutputReportLayout = ({
  loading,
  linkName,
  textForDate,
  date,
  Icon,
}: {
  loading: boolean;
  linkName: string;
  textForDate: string;
  date?: string;
  Icon: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  >;
}) => {
  const theme = useTheme();

  return (
    <>
      <Grid sx={{ width: "100%", margin: "10px 0", display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
        <Grid sx={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center", flex: 1 }}>
          <Icon style={{ width: "25px" }} />
          <Typography sx={{ whiteSpace: "nowrap", color: darken(theme.palette.text.secondary, 0.15) }}>
            {linkName}
          </Typography>
        </Grid>

        <Grid sx={{ display: "flex", flexDirection: "row-reverse", flex: 1 }}>
          <Grid sx={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center", marginLeft: "20px" }}>
            <Typography sx={{ whiteSpace: "nowrap", color: theme.palette.primary.main, fontWeight: "bold" }}>
              {textForDate}
            </Typography>
            {!!date && !loading && (
              <Typography sx={{ whiteSpace: "nowrap", color: theme.palette.primary.main, fontWeight: "bold" }}>
                {date}
              </Typography>
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
export default MyTeamPayrollOutputReportLayout;
